import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TabActionLogo from "./TabActionLogo";
import TabAction from "./TabAction";

// ── Types ─────────────────────────────────────────────────────────────────────

interface TrackingDrawerProps {
  open: boolean;
  onClose: () => void;
}

// ── Styles ────────────────────────────────────────────────────────────────────

const s: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 20px",
    borderBottom: "1px solid #f0f0f0",
    background: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 10,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  accent: {
    width: "4px",
    height: "20px",
    background: "#F8B71F",
    borderRadius: "999px",
    display: "inline-block",
  },
  title: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#1a1a1a",
    letterSpacing: "0.01em",
    fontFamily: "inherit",
  },
  closeBtn: {
    width: "32px",
    height: "32px",
    borderRadius: "8px",
    background: "#f5f5f5",
    color: "#374151",
  },
  body: {
    padding: "16px 20px",
    display: "flex",
    flexDirection: "column" as const,
    gap: "12px",
    flex: 1,
    // overflowY: "auto" as const,
  },
};

// ── Component ─────────────────────────────────────────────────────────────────

function TrackingDrawer({ open, onClose }: TrackingDrawerProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "100%", md: "96%", lg: 1200 },
          background: "#f7f7f7",
          boxShadow: "-4px 0 32px rgba(0,0,0,0.10)",
          display: "flex",
          flexDirection: "column",
          fontFamily: "'Inter', sans-serif",
        },
      }}
    >
      {/* Header */}
      <div style={s.header}>
        <div style={s.headerLeft}>
          <span style={s.accent} />
          <span style={s.title}>Tracking Details</span>
        </div>
        <IconButton onClick={onClose} size="small" sx={s.closeBtn} disableRipple>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </div>

      {/* Body */}
      <div style={s.body}>
        <TabActionLogo />
        <TabAction  />
      </div>
    </Drawer>
  );
}

export default TrackingDrawer;
